import { render, staticRenderFns } from "./AreaPOABudgetRequests.vue?vue&type=template&id=021d5d64"
import script from "./AreaPOABudgetRequests.vue?vue&type=script&lang=js"
export * from "./AreaPOABudgetRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports